// FIX: helper compartido — llama al Edge Function "enviar-push" que manda
// la notificación real al teléfono de cada correo en la lista. Nunca
// bloquea ni rompe el flujo principal si falla (el aviso es un plus, no
// algo de lo que dependa la acción que se está haciendo).
const PUSH_FUNCTIONS_URL = 'https://sicnbvbiukyaqkerajxd.supabase.co/functions/v1/enviar-push';
const PUSH_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNpY25idmJpdWt5YXFrZXJhanhkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY0MzE3NTMsImV4cCI6MjA5MjAwNzc1M30.wAkZ99Tk1eG1u4ALJPyajj9B8G3pFlYLMmHILtFFTF8';

export async function enviarPush({ correos, title, body, url, badgeCount }) {
  if (!correos || correos.length === 0) return;
  try {
    await fetch(PUSH_FUNCTIONS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${PUSH_ANON_KEY}`,
        'apikey': PUSH_ANON_KEY,
      },
      body: JSON.stringify({ correos, title, body, url, badgeCount }),
    });
  } catch (err) {
    // silencioso a propósito — un push fallido no debe romper el flujo principal
  }
}
